import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "kl-report-toolbar",
  templateUrl: "./report-toolbar.component.html",
  styleUrls: ["./report-toolbar.component.scss"],
})
export class ReportToolbarComponent implements OnInit {
  // inputs
  @Input() alertMessage: string;
  @Input() alertType: string;
  @Input() gridHeaderName: string;
  @Input() alertShow: boolean;

  // outputs
  @Output() onRefresh = new EventEmitter();
  @Output() onFieldsOpen = new EventEmitter();
  @Output() onTemplateOpen = new EventEmitter();
  @Output() onExport = new EventEmitter();
  @Output() onCloseAlert = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  refresh() {
    this.onRefresh.emit();
  }

  fieldsOpen() {
    this.onFieldsOpen.emit();
  }

  templateOpen() {
    this.onTemplateOpen.emit();
  }

  exportAs(type) {
    this.onExport.emit(type);
  }

  closeAlert() {
    this.onCloseAlert.emit();
    this.alertShow = false;
  }
}
